import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { fetchTop20IfNeeded, fetchTop20Counter } from '~/features/actions'
import unescape from 'lodash/unescape'
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { DateTime } from 'luxon'
class Top20Feature extends React.Component {

  componentDidMount() {
    const { match, history, dispatch } = this.props
    dispatch(fetchTop20IfNeeded())
  }

  render() {
    const { top20 } = this.props

    if (top20.items.length > 0) {
      let part = top20.items
      let date = DateTime.fromISO(top20.field_top_list_date[0].value).plus({ days: 7 }).toLocaleString(DateTime.DATE_SHORT)
      return (
        <div className="top-20-feature">
          <div className="margin">
            <Link to="/program/the-chart-show">
            <div className="text">
              <div className="zed">4ZZZ</div>
              <div className="top">TOP</div>
              <div className="twenty">20</div>
              <div className="date">{date}</div>
            </div>
            </Link>
            <div className="items">
            { part.map((item, index) => {
                return (
                  <div className="item" key={index} >
                    <div className="listing">
                      <span className="number">{item.pos}</span>
                      <span className="artist">{unescape(item.artist)}</span>
                      <span className="title">{unescape(item.title)}</span>
                    </div>
                  </div>
                )
            })
            }
            </div>
          </div>
        </div>
      )
    }
    else {
      return (
        <div>TOP 20</div>
      )
    }
  }
}

export default connect(state => { return { top20: state.top20 }}) (Top20Feature)
